import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/global.css'
import request from "@/utils/request";
Vue.config.productionTip = false
Vue.use(ElementUI,{ size:'small' })  //调整边框，按钮大小 medium small mini
Vue.prototype.$request = request
Vue.prototype.$baseUrl = process.env.VUE_APP_BASEURL  //如果在本地访问本地地址，在线上访问线上地址
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
